<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
  // eventsModule.init(30, 2);
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue